import { useState, useEffect, useCallback } from 'react'
import { useToast } from '@/hooks/use-toast'
import { useAccount } from 'wagmi'
import { wagmiConfig } from '@/constants/walletConnectionConfig'
import { useAppKit, useAppKitEvents } from '@reown/appkit/react'
import { useMobile } from './use-mobile'
import { disconnect } from '@wagmi/core'

export const useWallet = () => {
  const [error, setError] = useState<string | null>(null)
  const { toast } = useToast()
  const {
    address: walletAddress,
    chainId,
    isConnected,
    isConnecting,
    status: connectionStatus
  } = useAccount()

  const { open } = useAppKit()
  const walletEvents = useAppKitEvents()
  const { isMobile } = useMobile()

  //TODO: can be used as alternative solution for mobile connection
  const connectWalletMobile = (open: any) => {
    const isMetaMaskBrowser = navigator?.userAgent?.includes('MetaMaskMobile')
    if (isMobile && !isMetaMaskBrowser) {
      const dappUrl = location.href
      let metaMaskUrl = `https://metamask.app.link/dapp/${dappUrl}`
      window.open(metaMaskUrl, '_blank')
    } else {
      open({ view: 'Connect' })
    }
  }

  const connectWallet = async () => {
    try {
      await open({ view: 'Connect' })
      // connectWallet(open)
    } catch (error: any) {
      toast({
        title: 'Error',
        description: `Can't connect wallet. Reason: ${error?.message}`,
        variant: 'destructive',
        duration: 10000
      })
    }
  }

  const disconnectWallet = useCallback(async () => {
    await disconnect(wagmiConfig)
    setError(null)
    toast({
      title: 'Wallet Disconnected',
      description: 'Successfully disconnected from your wallet'
    })
  }, [toast, wagmiConfig])

  useEffect(() => {
    if (walletEvents.data.event === 'CONNECT_ERROR') {
      console.log('walletEvents error: ', walletEvents.data.properties.message)

      if (walletEvents.data.properties.message === 'Connector not found') {
        toast({
          title: 'Cannot Connect Wallet',
          description:
            "Please try reloading the page. If you don't have a wallet, obtain one using All Wallets, then reload the page",
          variant: 'destructive'
        })
      }
      if (
        walletEvents.data.properties.message.includes(
          'Already processing eth_requestAccounts'
        )
      ) {
        toast({
          title: 'Already processing account connection',
          description:
            'Please check your wallet for a pending connection request',
          variant: 'destructive'
        })
      }
    }
  }, [walletEvents.data.event])

  return {
    walletAddress,
    chainId,
    connectionStatus,
    isConnected,
    isConnectingWallet: isConnecting,
    error,
    connectWallet,
    disconnectWallet
  }
}
